import React from "react";
import { Route, Switch } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";

import Login from "../views/Login";
import routes from "../routes.js";
import { ErrorBoundary } from "react-error-boundary";
import LayoutErrorFallback from "./LayoutErrorFallback";
import { useConfig } from "../context/ConfigContext.jsx";

function AuthLayout() {
  const features = useConfig("genesis.features.gdec") ?? {};

  const getRoutes = (routes) => {
    return routes.filter((prop) => prop.name != "Certificates" || features.certificates).filter((prop) => prop.name != "").map((prop, key) => {
      if (prop.area === "auth") {
        return <Route path={prop.path} component={prop.component} key={key} />;
      } else {
        return null;
      }
    });
  };

  return (
    <div className="main-content full-background login-background d-flex flex-column justify-content-center">
      <div className="header mb-9">
        <Container>
          <div className="header-body text-center">
            <img alt="..." src={require("../assets/img/brand/logo-genesis-positive.png")} className="img-fluid mb-3" style={{ width: 251 }} />
          </div>
        </Container>
      </div>
      <Container className="mt--9 pb-5">
        <Row className="justify-content-center">
          <ErrorBoundary FallbackComponent={LayoutErrorFallback}>
            <Switch>
              {getRoutes(routes)}
              <Route path="*" component={Login} />
            </Switch>
          </ErrorBoundary>
        </Row>
      </Container>
    </div>
  );
}

export default AuthLayout;
